import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';

export default {
  attributeName: 'details',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,  
  emptyMessage: 'No Billing transactions to show',
  emptyMessage: "There are no billing transactions to show for this organization.",
  fields: [
    {
      attributeName: 'token',
      label: 'code',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Token name',
      canEdit: false,
      canCreate: false,
      width: '12rem',

    },
    {
      attributeName: 'appName',
      label: 'Room or App',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Name of the Room or App',
      canEdit: false,
      canCreate: false,
      width: '12rem',

    },
    {
      attributeName: 'appProviderName',
      label: 'VT Provider',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Provider assigned.',
      canEdit: false,
      canCreate: false,
      width: '12rem',

    },
    
    {
      attributeName: 'agreementUrl',
      label:'Agreement',
      type: FormInputTypes.LINK,
      icon: IconType.HANDSHAKE,
      width: '4rem',
      target:'_self',
      iconSize:'2x',
      iconColor:'#17a2b8',
      helpText: 'Live monitor for this event.',
    },   
    {
      attributeName: 'price',
      label: 'Price €',
      type: FormInputTypes.NUMBER,
      helpText: 'Price of agreement',
      canEdit: false,
      canCreate: false,
      width: '12rem',

    },
    {
      attributeName: 'revenue',
      label: 'Revenue %',
      type: FormInputTypes.NUMBER,
      helpText: 'Revenue of agreement',
      canEdit: false,
      canCreate: false,
      width: '12rem',

    }        

    
  ],
};
